import {Body, Close, Header, Modal} from "@zendeskgarden/react-modals";
import {ReactElement, useRef} from "react";
import {INumbersTable, NumbersTable, NumbersTableHandle} from "./NumbersTable";
import css from "../../pages/portfolio-financial/styles/css.module.scss";
import modalCss from "./accountPropertiesModal.module.scss";
import {TTableRow} from "./types";
import {formatterGlName} from "../../utils/formatters";
import {Button} from "@zendeskgarden/react-buttons";

export type IAccountPropertiesModal = {
    onClose: () => void;
} & INumbersTable
& {
    glTotalRow: TTableRow;
};

export function AccountPropertiesModal(props: IAccountPropertiesModal): ReactElement | null {
    const nameComponents = props.glTotalRow.name as {name: string, number: string};
    const glName = formatterGlName(nameComponents.name, nameComponents.number);
    const numbersTableRef = useRef<NumbersTableHandle>(null);
    return (
        <Modal
            onClose={() => props.onClose()}
            isLarge
            // NOTE: keep isAnimated false to prevent NumbersTable component from using not fully opened modal width and height
            isAnimated={false}
            className={modalCss.modal}
        >
            <Header>
                <div className={modalCss.headerContent}>
                    <span>{glName} by Property</span>
                    <Button onClick={() => numbersTableRef.current?.exportAsCsv(`${glName} by Property/`)}>
                        Export
                    </Button>
                </div>
            </Header>
            <Body>
                <div className={css.wrapper} style={{padding: 0, margin: 0, height: "100%"}}>
                    <div className={css.tableWrapper}>
                        <div className={css.tableOuter}>
                            <NumbersTable
                                ref={numbersTableRef}
                                {...props}
                                firstColumnLabel="Property Name"
                                disableIndentPropertyName
                            />
                        </div>
                    </div>
                </div>
            </Body>
            <Close aria-label="Close modal" />
        </Modal>
    );
}